import { defineElement, html, TemplateElement } from '@webtides/element-js';
import '../../mgnl/mgnl-editable-area.js';

export class EBankingPage extends TemplateElement {
    properties() {
        return {
            content: {},
        };
    }

    template() {
        return html`<div class="w-full mx-auto migros-bank--light">
            <mgnl-editable-area class="flex flex-col gap-y-fix-m" .content="${this.content?.main}"></mgnl-editable-area>
        </div>`;
    }
}

defineElement('editable-e-banking-page', EBankingPage);
